import React, { useEffect, useState } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//hook
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import MemberDetail from './Member.Detail';
import MemberDetailBottomsheet from './bottomsheet/MemberDetail';//회원정보-bottomsheet

export default function Member(props) {
    const { data, toggle, setToggle } = props;//props
    const { axiosPostHandler } = useAxiosHook();//axios
    const { partner } = usePartnerStore();
    const { windowSize, windowResizeHandler } = useComnHook();//화면사이즈핸들러

    /* =============== 회원별예약상세내역 =============== */
    const [ memberDetail,setMemberDetail ] = useState([]);
    const memberReservDetailAPI = async() => {
        const DATA = { MEMBER_CD:data.MEMBER_CD, PARTNER_CD:partner.COMN_CD };
        const result = await axiosPostHandler(`memberReservDetailListForPartner.do`, DATA);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            setMemberDetail(result.data);
        }
    };
    useEffect(() => {
        if(data !== toggle) { return; }
        
        memberReservDetailAPI();
    }, [toggle]);
    /* =============== 회원별예약상세내역 =============== */
    /* =============== 화면리사이즈 =============== */
    useEffect(() => {
        windowResizeHandler();
    }, []);
    /* =============== 화면리사이즈 =============== */
    /* =============== 팝업오픈여부 =============== */
    const [ isOpen,setOpen ] = useState(false);
    const onDismissHandler = (value) => {
        setOpen(value);
    }
    useEffect(() => {
        if(data !== toggle) { return; }
        
        let result = false;
        if(windowSize.width <= 767) { result = true; }
        
        if(result === isOpen) { return; } 
        onDismissHandler(result);
    }, [toggle, windowSize]);
    /* =============== 팝업오픈여부 =============== */

    return (
        <>
        <Element tag={`div`}>
            <Element tag={`div`}>
                <Element tag={`label`}>{data.MEMBER_NAME}</Element>
                <Element tag={`span`}>{`${data.RESERV_CNT}회 재예약 | ${data.NOSHOW_CNT}회 노쇼`}</Element>
                <Element tag={`strong`}>정비이력 {data.LAST_RESERV_DT}</Element>
            </Element>
            <Element tag={`div`}>
                <Element tag={`small`}><Element tag={`span`}>마지막 방문</Element><Element tag={`em`}>{data.LAST_RESERV_DT}</Element></Element>
            </Element>
        </Element>
        {toggle === data && memberDetail.length > 0 ? 
            <MemberDetail data={memberDetail} />
        : null}
        {isOpen && memberDetail.length > 0 ? <MemberDetailBottomsheet data={memberDetail} isOpen={isOpen} onDismiss={onDismissHandler} /> : null}
        </>
    );
}